import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/pages/Home.vue'),
    },
    {
        path: '/create',
        name: 'RoomCreate',
        component: () => import('@/pages/RoomCreate.vue'),
        meta: {
            title: 'Create room',
        },
    },
    {
        path: '/join',
        name: 'RoomJoin',
        props: true,
        component: () => import('@/pages/RoomJoin.vue'),
        meta: {
            title: 'Join room',
        },
    },
    {
        path: '/settings',
        name: 'Settings',
        props: true,
        component: () => import('@/pages/Settings.vue'),
        meta: {
            title: 'Settings',
        },
    },
    {
        path: '/r/:code',
        name: 'RoomShow',
        component: () => import('@/pages/RoomShow.vue'),
        beforeEnter: (to, from, next) => {
            to.params.code === store.state.room.code
                ? next()
                : next({
                      name: 'RoomJoin',
                      params: {
                          code: to.params.code,
                      },
                  });
        },
    },
    {
        path: '/r/:code/setup',
        name: 'RoomShowSetup',
        component: () => import('@/pages/RoomShowSetup.vue'),
    },
    {
        path: '*',
        component: () => import('@/pages/NotFound.vue'),
        meta: {
            title: '404',
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

// Set the title
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'Ring of Fire';
    next();
});

Vue.use(VueRouter);
export default router;
